import { APP_PDC_URL } from "../../../config";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";
import { callWithRetry } from "../../services/callWithRetry";

export const detailsDocumentConstants = {
  CLEAR_DETAIL: "CLEAR_DETAIL",

  GET_DOCUMENTS_DETAILS_ERROR: "GET_DOCUMENTS_DETAILS_ERROR",
  GET_DOCUMENTS_DETAILS_START: "GET_DOCUMENTS_DETAILS_START",
  GET_DOCUMENTS_DETAILS_SUCCESS: "GET_DOCUMENTS_DETAILS_SUCCESS",

  REMOVE_DOCUMENTS_START: "REMOVE_DOCUMENTS_START",
  REMOVE_DOCUMENTS_SUCCESS: "REMOVE_DOCUMENTS_SUCCESS",
  REMOVE_DOCUMENTS_ERROR: "REMOVE_DOCUMENTS_ERROR",

  SET_DOCUMENT_VISIBILITY_STUDIO_START: "SET_DOCUMENT_VISIBILITY_STUDIO_START",
  SET_DOCUMENT_VISIBILITY_STUDIO_SUCCESS: "SET_DOCUMENT_VISIBILITY_STUDIO_SUCCESS",
  SET_DOCUMENT_VISIBILITY_STUDIO_ERROR: "SET_DOCUMENT_VISIBILITY_STUDIO_ERROR"
};
export function clearDetail() {
  return function(dispatch) {
    return dispatch({
      type: detailsDocumentConstants.CLEAR_DETAIL
    });
  };
}

export function getDetailDocument(documentId) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const accountantIdSelected = getState().main.accountantIdSelected;
    const clientIdSelected = getState().main.clientIdSelected;
    let urlRequest = APP_PDC_URL +
    "/v2/documents/" +
    documentId +
    "?accountantId=" +
    accountantIdSelected +
    "&itemId=" +
    clientIdSelected;

    return new Promise(function(resolve, reject) {
      dispatch({
        type: detailsDocumentConstants.GET_DOCUMENTS_DETAILS_START
      });

      let request = {
        method: "GET",
        url: urlRequest,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then(result => {
          let standardTagsRes = result.data.standardTags;
          standardTagsRes = standardTagsRes
            ? standardTagsRes.find(el => el.key === "category")
            : [];
          let categoryTrueValue = standardTagsRes
            ? standardTagsRes.value
            : null;
          result.data["realCategory"] = categoryTrueValue;
          dispatch({
            type: detailsDocumentConstants.GET_DOCUMENTS_DETAILS_SUCCESS,
            payload: result.data
          });
          resolve(result.data);
        })
        .catch(response => {
          if (response.message === "Request failed with status code 400") {
            response.code = 400;
          }

          dispatch({
            type: detailsDocumentConstants.GET_DOCUMENTS_DETAILS_ERROR,
            payload: {
              message: "Si è verificato un errore",
              code: response && response.code ? response.code : 500
            }
          });
          reject(response);
        });
    });
  };
}

export function removeDocument(
  auth,
  accountantSelected,
  accountantIdSelected,
  companySelected,
  clientIdSelected,
  id
) {
  let url = `${APP_PDC_URL}/v2/documents/${id}?itemId=${clientIdSelected}&accountantId=${accountantIdSelected}`;

  let request = {
    method: "delete",
    url: url,
    headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
  };

  return dispatch => {
    return new Promise(function(resolve, reject) {
      dispatch({
        type: detailsDocumentConstants.REMOVE_DOCUMENTS_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(result => {
          dispatch({
            type: detailsDocumentConstants.REMOVE_DOCUMENTS_SUCCESS,
            payload: { idDoc: id }
          });
          resolve(result.data);
        })
        .catch(response => {
          dispatch({
            type: detailsDocumentConstants.REMOVE_DOCUMENTS_ERROR
          });
          reject(response);
        });
    });
  };
}

export function setDocumentVisibility(
  auth,
  accountantSelected,
  accountantIdSelected,
  companySelected,
  clientIdSelected,
  documentId,
  isVisibleByStudioOnly
) {
  const requestPut = {
    method: "PATCH",
    url: `${APP_PDC_URL}/v2/documents/${documentId}/toggleVisibility`,
    headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
    data: {
      visibleByStudioOnly: !isVisibleByStudioOnly,
      itemId: clientIdSelected,
      accountantId: accountantIdSelected
    }
  };

  return dispatch => {
    return new Promise(function(resolve, reject) {
      dispatch({
        type: detailsDocumentConstants.SET_DOCUMENT_VISIBILITY_STUDIO_START
      });

      callWithRetry(
        auth, requestPut, dispatch
      )
        .then(result => {
          dispatch({
            type: detailsDocumentConstants.SET_DOCUMENT_VISIBILITY_STUDIO_SUCCESS,
            payload: {
              isVisibleByStudioOnly: !isVisibleByStudioOnly,
              documentID: documentId
            }
          });
          resolve(result.data);
        })
        .catch(response => {
          dispatch({
            type: detailsDocumentConstants.SET_DOCUMENT_VISIBILITY_STUDIO_ERROR
          });
          reject(response);
        });
    });
  };
}
